import { AnalogIn, AnalogOut, DigitalIn, DigitalOut, IOType } from "../../props/PropTypes";
import { BusManagerBase } from "./BusManagerBase";
import { HdwRackType, isCombiKaart, isSimpleKaart, isSysteemKaart, KaartType } from "./hdw-konfig-types";
import { BusManager, HwdSysteem, Kaart, Rack } from "./HdwSysteem";

const findLastIndex = function (a: any[], predicate: (v: any) => boolean) {
    for (let i = a.length - 1; i >= 0; i--) {
        if (predicate(a[i])) {
            return i;
        }
    }
    return -1;
};

export class FastLinkBusManager extends BusManagerBase implements BusManager {
    constructor(systeem: HwdSysteem) {
        super(systeem, "fastlink");
    }


    public canDeleteRack(rackId: number): boolean {
        let rack = this.getRack(rackId);
        if (rack?.type.hideNumber == true) {
            return false;
        }
        return true;
    }
    deleteRack(id: number): void {
        super.deleteRack(id);
        let racks = this.getRacks();
        for (let i = 0; i < racks.length; i++) {
            racks[i].number = i;
        }

        this.assignOffsets();
    }
    deleteKaart(id: number): void {
        super.deleteKaart(id);
        this.assignOffsets();
    }

    public getNextRackId(rackType: HdwRackType) {
        let id = this.systeem.getNextRackId();
        return id - 1;
    }
    addRack(rackType: HdwRackType): number {
        let id = super.addRack(rackType);
        let rack = this.getRack(id);
        if (rack != undefined) {
            rack.number = this.getRacks().length - 1;
            if (rackType.karten.length > 0) {
                let nr = rack.number - 1;
                let kaart = new Kaart(rackType.karten[0], 0, this.systeem.getNextKaartId(), nr);
                rack.addKaart(kaart);

            }
        }
        this.assignOffsets();
        return id;

    }


    addKaart(kaartType: KaartType, number: number, rackId: number): number {
        let rack = this.getRack(rackId);
        if (rack != undefined) {
            let id = this.systeem.getNextKaartId();
            let firstRack = this.getRacks()[0];
            let dipSwitch = 0;
            if (firstRack.id == rack.id) {
                dipSwitch = firstRack.getNextNumber() - 1;
            } else {
                let aikartsNo = this.getRacks().filter(r => r.id != firstRack.id).flatMap(r => {
                    let aiKarten = r.kaarten.filter(k => !isSysteemKaart(k.type));

                    return aiKarten;
                });
                if (aikartsNo.length == 0) {
                    dipSwitch = 0;
                } else {
                    let max = aikartsNo.reduce((max, v) => Math.max(max, v.dipSwitch), 0);
                    dipSwitch = max + 1;
                }
            }
            let kaart = new Kaart(kaartType, number, id, dipSwitch);
            rack.addKaart(kaart);
            this.assignOffsets();
            return id;
        }
        return -1;
    }

    public sortRack(rack: Rack) {
        rack.kaarten.sort((kaart1, kaart2) => {
            if (!kaart1.type.takesRackSpace) {
                return -1;
            } else if (!kaart2.type.takesRackSpace) {
                return 1;
            }
            return kaart1.number - kaart2.number
        });

    }

    public sortRacks(racks: Rack[]) {
        racks.sort((r1, r2) => {
            let x1 = r1.kaarten.findIndex(this.xtPredicate);
            let x2 = r2.kaarten.findIndex(this.xtPredicate);
            if (x1 == -1) {
                return 1;
            } else if (x2 == -1) {
                return -1;
            }

            return r1.kaarten[x1].dipSwitch - r2.kaarten[x2].dipSwitch;
        });
        for (let rack of racks) {
            this.sortRack(rack);
        }
    }

    public assignOffsets() {
        let racks = this.systeem.getRacks("fastlink");
        //Sort the racks by the number of the XTender card
        this.sortRacks(racks);

        this.assignOffsetsFor(AnalogIn);
        this.assignOffsetsFor(AnalogOut);
        this.assignOffsetsFor(DigitalIn);
        this.assignOffsetsFor(DigitalOut);
    }

    private xtPredicate = (k: Kaart) => {
        if (isSysteemKaart(k.type)) {
            return true;
        }
        return false;
    }


    private addKarts(dest: Kaart[], src: Kaart[], ioType: IOType) {
        for (let kaart of src) {
            if (isSimpleKaart(kaart.type) && new IOType(kaart.type.ioType).equals(new IOType(ioType))) {
                dest.push(kaart);
            }
            if (isCombiKaart(kaart.type)) {
                dest.push(kaart);
            }
        }
    }

    public assignOffsetsFor(ioType: IOType) {
        let cards: Kaart[] = [];
        let xtCards: Kaart[] = [];
        let racks = this.systeem.getRacks("fastlink");
        let mainRack = racks[0];
        let masterXTIdx = findLastIndex(mainRack.kaarten, this.xtPredicate);
        if (masterXTIdx == -1) {
            return;
        }
        let masterXT = mainRack.kaarten[masterXTIdx];
        if (masterXT.type.takesRackSpace == false) {
            this.addKarts(cards, mainRack.kaarten, ioType);
        } else {
            this.addKarts(cards, mainRack.kaarten.slice(0, masterXTIdx), ioType);
            for (let rack of racks.slice(1)) {
                this.addKarts(xtCards, rack.kaarten, ioType);
            }
            xtCards.sort((a, b) => a.dipSwitch - b.dipSwitch);
            this.addKarts(cards, xtCards, ioType);
            this.addKarts(cards, mainRack.kaarten.slice(masterXTIdx), ioType);
        }
        console.log("Here1");
        let startOffset = this.systeem.getStartingOfsset(this.bustype, ioType);
        if (ioType.equals(AnalogIn)) {
            startOffset = startOffset + 2;
        } else {
            startOffset = startOffset + 1;
        }
        for (let kaart of cards) {
            kaart.setOffset(startOffset, ioType);
            startOffset += kaart.getReservedIOS(ioType);
        }
    }

}